var _defs, _path, _g, _path2, _g2, _path3, _g3, _path4, _path5, _path6, _path7, _path8, _path9, _g4, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _ellipse, _path28, _path29, _path30, _ellipse2, _ellipse3, _path31, _path32, _path33, _path34, _path35, _ellipse4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWomanPortfolio2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 810.708,
    height: 806.186,
    viewBox: "0 0 810.708 806.186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.195,
    y1: 1.166,
    x2: -0.595,
    y2: -0.399,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa80f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#6165d7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.13,
    y1: 0.181,
    x2: 1.162,
    y2: 1.357,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#e38ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571f6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_230786",
    "data-name": "Path 230786",
    d: "M965.759,1152.821c-6.694,11.1-18.358,26.161-30.986,43.632l210.766,30.517c-23.576-64.183-56.812-131.588-7.173-243.035,23.294-52.3,85.207-144.251,59.723-205.571-29.032-69.861-86.471-39.695-101.044-93.781C1074.267,600.045,1002.307,541.237,925,583.25c-76.3,41.465-73.736,192.968,26.8,358.707C1010.454,1069.029,1000.713,1094.881,965.759,1152.821Z",
    transform: "translate(-871.63 -569.346)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_230792",
    "data-name": "Path 230792",
    d: "M765.177,1359.7c1.147,97.841,48.338,65.6,91.853,75.258,50.221,72.663,54.953,140.08-20.031,198.3l-83.55-12.5c-31-1.439-67.377-10.914-65.324-52.193,2.321-46.686,13.362-76.338-39.334-99.266S573.46,1404.54,594.8,1356.953c22.456-50.077-30.216-117.578,8.278-151.13C670.149,1147.36,763.982,1257.823,765.177,1359.7Z",
    transform: "translate(-586.822 -1189.573)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.538,
    y1: -0.982,
    x2: 1.171,
    y2: 1.492,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#f36f56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.144,
    y1: 0.004,
    x2: 1.852,
    y2: 2.479,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.168,
    y1: -0.519,
    x2: 0.902,
    y2: 1.657,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.243,
    y1: 0.001,
    x2: 0.685,
    y2: 1.487,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#26264f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.525,
    y1: 3.978,
    x2: 0.482,
    y2: -1.365,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 75.735,
    y1: -2.425,
    x2: 75.937,
    y2: 2.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 283.671,
    y1: 1.152,
    x2: 283.535,
    y2: -5.073,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#893976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311944"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 130.368,
    y1: -1.495,
    x2: 130.688,
    y2: 1.478,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 218.012,
    y1: 1.353,
    x2: 217.915,
    y2: -3.033,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 39.315,
    y1: 0.5,
    x2: 40.315,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ab316d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792d3d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 42.309,
    y1: 0.5,
    x2: 43.309,
    y2: 0.5,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 20.308,
    y1: 0.5,
    x2: 21.308,
    y2: 0.5,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 8.587,
    y1: 0.229,
    x2: 8.957,
    y2: 0.772,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#26264f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444b8c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 90.917,
    y1: 0.5,
    x2: 91.917,
    y2: 0.5,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 14.887,
    y1: -1.014,
    x2: 14.311,
    y2: 6.865,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 9.98,
    y1: -0.548,
    x2: 9.65,
    y2: 3.212,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 24.436,
    y1: 0.342,
    x2: 24.034,
    y2: 0.984,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#6165d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa80f9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 24.904,
    y1: 0.302,
    x2: 23.9,
    y2: 0.823,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb6fbb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 84.882,
    y1: -2.991,
    x2: 84.459,
    y2: 0.705,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 33.937,
    y1: 0.247,
    x2: 32.557,
    y2: 0.781,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 67.823,
    y1: 0.5,
    x2: 68.823,
    y2: 0.5,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 11.156,
    y1: 0.5,
    x2: 12.156,
    y2: 0.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 22.817,
    y1: -0.844,
    x2: 22.041,
    y2: 4.908,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 40.935,
    y1: 13.242,
    x2: 41.692,
    y2: 11.582,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 119.908,
    y1: 19.707,
    x2: 123.881,
    y2: 17.817,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1.522,
    y1: 0.577,
    x2: -0.194,
    y2: 0.422,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 1.524,
    y1: 0.575,
    x2: -0.198,
    y2: 0.428,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 0.589,
    y1: -1.51,
    x2: 0.777,
    y2: -5.724,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -0.225,
    y1: -3.694,
    x2: 0.707,
    y2: 1.7,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -0.368,
    y1: -2.215,
    x2: 0.892,
    y2: 1.1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a03976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -0.665,
    y1: -0.607,
    x2: 0.752,
    y2: 0.747,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -0.31,
    y1: -2.809,
    x2: 0.896,
    y2: 1.108,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 0.488,
    y1: -3.089,
    x2: 0.511,
    y2: 3.252,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 0.498,
    y1: -3.087,
    x2: 0.501,
    y2: 3.252,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 0.485,
    y1: -3.081,
    x2: 0.512,
    y2: 3.247,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 3.279,
    y1: 0.5,
    x2: 4.279,
    y2: 0.5,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 0.48,
    y1: -3.081,
    x2: 0.513,
    y2: 3.246,
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2143",
    "data-name": "Group 2143",
    transform: "translate(-456.623 -483.063)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_230754",
    "data-name": "Path 230754",
    d: "M1255.408,827.41c-21.974-143.83-112.067-320.535-290.056-339.027,0,0-135.137-16.437-268.353,8.475-79.064,14.785-148.391,58.8-192.258,122.057S446.22,759.308,464,832.847c11.55,47.764,19.356,97.2,17.213,146.278-3.728,85.42-1.583,165.153,81.315,216.095,74.018,45.485,167.171,85.6,256.041,92.628,60.395,4.775,128.124-2.952,186.333-18.676C1301.552,1189.039,1277.382,971.239,1255.408,827.41Z",
    transform: "translate(0 0)",
    fill: "#daecff",
    opacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2118",
    "data-name": "Group 2118",
    transform: "translate(719.227 510.39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2114",
    "data-name": "Group 2114",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2113",
    "data-name": "Group 2113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2112",
    "data-name": "Group 2112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_230755",
    "data-name": "Path 230755",
    d: "M1764.962,760.163l-22.978.04a163.736,163.736,0,0,0-10.662-43.436L1750.75,705.5a11.491,11.491,0,0,0,4.064-15.528l-8.164-14.682a11.2,11.2,0,0,0-15.283-4.526l-19.186,10.889a168.9,168.9,0,0,0-31.659-33.5l11.035-18.957a11.933,11.933,0,0,0-4.205-16.005l-14.687-9.113a11.36,11.36,0,0,0-15.9,3.655L1645.7,626.495a171.873,171.873,0,0,0-45.767-13.956v-22.25a12.663,12.663,0,0,0-12.082-12.436l-17.882-.816a11.507,11.507,0,0,0-12.27,11.456v22.494a173.951,173.951,0,0,0-47.925,10.952L1497.84,601.6a13.377,13.377,0,0,0-17.413-5.157l-16.353,8.387a11.731,11.731,0,0,0-4.731,16.652l12.368,20.806a172.709,172.709,0,0,0-35.889,34.018l-22.371-12.657c-6.343-3.589-14.482-1.728-18.168,4.175l-9.835,15.752c-3.711,5.943-1.508,13.655,4.908,17.205l23.149,12.81a165.3,165.3,0,0,0-12.641,47.2l-27.767.048c-7.473.013-13.551,5.677-13.551,12.651v18.547c0,6.974,6.078,12.552,13.551,12.46l28.5-.355a163.714,163.714,0,0,0,13.914,45.885L1390.356,864.3c-6.416,3.641-8.619,11.384-4.908,17.275l9.835,15.612c3.686,5.851,11.825,7.6,18.168,3.918l25.448-14.758a169.71,169.71,0,0,0,35.116,31.387l-14.671,24.887a11.628,11.628,0,0,0,4.731,16.585l16.353,8.156a13.508,13.508,0,0,0,17.413-5.4l14.55-24.994a172.625,172.625,0,0,0,45.312,9.394v27.864a11.316,11.316,0,0,0,12.27,11.282l17.882-1.069a12.885,12.885,0,0,0,12.082-12.607V944.27a173.8,173.8,0,0,0,43.328-13.4l13.5,22.709a11.278,11.278,0,0,0,15.9,3.429l14.688-9.321a12.034,12.034,0,0,0,4.2-16.065l-13.1-22.326a172.37,172.37,0,0,0,31.057-31.9l21.857,12.1a11.308,11.308,0,0,0,15.283-4.742l8.164-14.8a11.393,11.393,0,0,0-4.064-15.47l-21.136-11.958a165.289,165.289,0,0,0,11.752-42.614l23.6-.293a11.338,11.338,0,0,0,11-11.478V771.485A11.146,11.146,0,0,0,1764.962,760.163ZM1578.934,897.282c-67.993,2.523-124.892-50.246-124.892-117.945s56.9-121.2,124.892-119.541c65.682,1.6,117.312,54.4,117.312,117.994S1644.617,894.845,1578.934,897.282Z",
    transform: "translate(-1359.545 -577.023)",
    fill: "#97a6b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230756",
    "data-name": "Path 230756",
    d: "M1798.623,639.429l-16.366-.564-5.643,14.673Z",
    transform: "translate(-1655.314 -620.879)",
    fill: "#97a6b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230757",
    "data-name": "Path 230757",
    d: "M2410.264,664.09l18.872.188V678.2Z",
    transform: "translate(-2104.675 -638.767)",
    fill: "#97a6b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230758",
    "data-name": "Path 230758",
    d: "M2657.547,894.97l18.811.76-4.7,10.534Z",
    transform: "translate(-2280.038 -802.498)",
    fill: "#97a6b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230759",
    "data-name": "Path 230759",
    d: "M2759.094,1207.4l19,1.5-6.208,9.218Z",
    transform: "translate(-2352.051 -1024.059)",
    fill: "#97a6b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230760",
    "data-name": "Path 230760",
    d: "M2650.432,1625.352l18.435,2.634,2.258-15.049Z",
    transform: "translate(-2274.992 -1311.653)",
    fill: "#97a6b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230761",
    "data-name": "Path 230761",
    d: "M2407.885,1866.642l16.554,3.01,1.317-12.227Z",
    transform: "translate(-2102.987 -1485.034)",
    fill: "#97a6b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230762",
    "data-name": "Path 230762",
    d: "M2087.059,1937.269l-14.861-2.634,12.792-19Z",
    transform: "translate(-1864.931 -1526.315)",
    fill: "#97a6b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230763",
    "data-name": "Path 230763",
    d: "M1804.269,1886.878l-17.306-3.574,13.356-16.178Z",
    transform: "translate(-1662.653 -1491.914)",
    fill: "#97a6b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230764",
    "data-name": "Path 230764",
    d: "M1512.075,869.123l18.059.564-7.148,13.168Z",
    transform: "translate(-1467.714 -784.169)",
    fill: "#97a6b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230765",
    "data-name": "Path 230765",
    d: "M1388.538,1329.1l16.554,2.446L1403.775,1318Z",
    transform: "translate(-1380.105 -1102.494)",
    fill: "#97a6b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230766",
    "data-name": "Path 230766",
    d: "M1510.782,1677.3l16.178,2.634,1.317-10.723Z",
    transform: "translate(-1466.796 -1351.558)",
    fill: "#97a6b7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_230767",
    "data-name": "Path 230767",
    d: "M1820.6,761.655l-23.168.04a165.054,165.054,0,0,0-10.75-43.791l19.589-11.359a11.584,11.584,0,0,0,4.1-15.655l-8.232-14.8a11.3,11.3,0,0,0-15.41-4.563L1767.381,682.5a170.258,170.258,0,0,0-31.921-33.773l11.127-19.111a12.029,12.029,0,0,0-4.24-16.136l-14.809-9.187a11.456,11.456,0,0,0-16.034,3.684L1700.353,626.9a173.325,173.325,0,0,0-46.146-14.07V590.4a12.767,12.767,0,0,0-12.181-12.538l-18.031-.823a11.6,11.6,0,0,0-12.372,11.549v22.678A175.4,175.4,0,0,0,1563.3,622.3l-12.036-20.5a13.49,13.49,0,0,0-17.558-5.2l-16.489,8.456a11.826,11.826,0,0,0-4.77,16.787l12.471,20.975a174.149,174.149,0,0,0-36.186,34.3l-22.557-12.76c-6.4-3.618-14.6-1.742-18.319,4.209l-9.916,15.88c-3.741,5.991-1.52,13.766,4.949,17.345l23.341,12.915a166.644,166.644,0,0,0-12.745,47.58l-28,.048c-7.535.013-13.664,5.723-13.664,12.754v18.7c0,7.031,6.129,12.655,13.664,12.561l28.741-.358a165.006,165.006,0,0,0,14.029,46.259l-25.368,14.4c-6.469,3.671-8.69,11.477-4.949,17.415l9.916,15.74c3.717,5.9,11.923,7.658,18.319,3.95l25.658-14.878a171.106,171.106,0,0,0,35.407,31.643l-14.793,25.09a11.722,11.722,0,0,0,4.77,16.72l16.489,8.222a13.621,13.621,0,0,0,17.558-5.448l14.671-25.2a174.075,174.075,0,0,0,45.688,9.47v28.091a11.409,11.409,0,0,0,12.372,11.374l18.031-1.078a12.991,12.991,0,0,0,12.181-12.71V947.263a175.265,175.265,0,0,0,43.687-13.506l13.612,22.894a11.372,11.372,0,0,0,16.034,3.457l14.809-9.4a12.131,12.131,0,0,0,4.24-16.2l-13.213-22.508a173.783,173.783,0,0,0,31.315-32.16l22.038,12.194a11.4,11.4,0,0,0,15.41-4.781l8.232-14.918a11.485,11.485,0,0,0-4.1-15.6l-21.311-12.056a166.621,166.621,0,0,0,11.849-42.961l23.792-.3a11.431,11.431,0,0,0,11.09-11.571V773.069A11.237,11.237,0,0,0,1820.6,761.655ZM1633.03,899.891c-68.556,2.544-125.927-50.656-125.927-118.906S1564.474,658.8,1633.03,660.47c66.227,1.611,118.284,54.847,118.284,118.955S1699.257,897.434,1633.03,899.891Z",
    transform: "translate(-1396.618 -577.023)",
    fill: "#d8dee8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2117",
    "data-name": "Group 2117",
    transform: "translate(259.45 382.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2116",
    "data-name": "Group 2116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2115",
    "data-name": "Group 2115"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_230768",
    "data-name": "Path 230768",
    d: "M2472.982,2010.252l-12.362-2.3a89.579,89.579,0,0,0-1.348-24.437l11.586-4.1a6.288,6.288,0,0,0,3.754-7.941l-2.908-8.72a6.129,6.129,0,0,0-7.762-3.977l-11.418,3.919a92.4,92.4,0,0,0-13.644-21.213l7.849-9.081a6.53,6.53,0,0,0-.646-9.032l-6.979-6.384a6.216,6.216,0,0,0-8.921.36l-7.843,8.973a94.053,94.053,0,0,0-23.2-12.126l2.246-11.966a6.929,6.929,0,0,0-5.241-7.908l-9.535-2.244a6.3,6.3,0,0,0-7.756,4.922l-2.271,12.1a95.18,95.18,0,0,0-26.88,1.052l-4.366-12.142a7.32,7.32,0,0,0-8.844-4.532l-9.642,2.859a6.419,6.419,0,0,0-4.225,8.478l4.551,12.438a94.512,94.512,0,0,0-22.736,14.671l-10.753-9.065a7.446,7.446,0,0,0-10.192.411l-6.879,7.478a6.682,6.682,0,0,0,.9,9.748l11.156,9.227a90.451,90.451,0,0,0-11.563,24.106l-14.938-2.778a7.2,7.2,0,0,0-8.565,5.436l-1.873,9.975a7.074,7.074,0,0,0,6.03,8.069l15.365,2.687a89.568,89.568,0,0,0,2.85,26.082l-14.973,5.139a6.741,6.741,0,0,0-4.384,8.795l3.713,9.389a7.391,7.391,0,0,0,9.375,3.941l15.176-5.367a92.86,92.86,0,0,0,15.716,20.425l-10.4,11.9a6.363,6.363,0,0,0,.869,9.4l7.971,6.037a7.391,7.391,0,0,0,9.91-1.148l10.349-11.973a94.468,94.468,0,0,0,23.42,9.627l-2.813,14.985a6.192,6.192,0,0,0,5.46,7.306l9.725,1.23a7.051,7.051,0,0,0,7.77-5.561l2.783-14.822a95.089,95.089,0,0,0,24.654-2.83l4.967,13.576a6.171,6.171,0,0,0,8.206,3.45l8.84-3.53a6.584,6.584,0,0,0,3.883-8.215l-4.793-13.33a94.328,94.328,0,0,0,19.923-14.02l10.533,8.711a6.187,6.187,0,0,0,8.7-1.007l5.885-7.134a6.234,6.234,0,0,0-.624-8.73l-10.159-8.565a90.444,90.444,0,0,0,10.622-21.731l12.72,2.224a6.2,6.2,0,0,0,7.074-5.062l1.682-8.958A6.1,6.1,0,0,0,2472.982,2010.252Zm-113.889,54.96c-36.821-5.508-62.093-39.632-55.258-76.04s42.837-59.433,79.236-51.679c35.162,7.491,57.6,41.1,51.176,75.3S2394.663,2070.532,2359.094,2065.211Z",
    transform: "translate(-2251.622 -1891.898)",
    fill: "#97a6b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230769",
    "data-name": "Path 230769",
    d: "M2552.867,1898.732l-8.744-1.956-4.517,7.321Z",
    transform: "translate(-2455.849 -1895.358)",
    fill: "#97a6b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230770",
    "data-name": "Path 230770",
    d: "M2882.927,1972.359l10.13,2.007-1.406,7.486Z",
    transform: "translate(-2699.319 -1948.958)",
    fill: "#97a6b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230771",
    "data-name": "Path 230771",
    d: "M2992.6,2121.492l10.04,2.308-3.593,5.19Z",
    transform: "translate(-2777.098 -2054.717)",
    fill: "#97a6b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230772",
    "data-name": "Path 230772",
    d: "M3015.671,2299.766l10.066,2.728-4.269,4.33Z",
    transform: "translate(-2793.456 -2181.143)",
    fill: "#97a6b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230773",
    "data-name": "Path 230773",
    d: "M2911.979,2518.664l9.648,3.277,2.734-7.865Z",
    transform: "translate(-2719.921 -2333.123)",
    fill: "#97a6b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230774",
    "data-name": "Path 230774",
    d: "M2757.963,2623.245l8.6,3.29,1.943-6.443Z",
    transform: "translate(-2610.7 -2408.305)",
    fill: "#97a6b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230775",
    "data-name": "Path 230775",
    d: "M2575.886,2627.586l-7.726-2.917,8.8-8.926Z",
    transform: "translate(-2476.099 -2405.221)",
    fill: "#97a6b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230776",
    "data-name": "Path 230776",
    d: "M2429.585,2572.073l-8.947-3.669,8.816-7.352Z",
    transform: "translate(-2371.482 -2366.436)",
    fill: "#97a6b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230777",
    "data-name": "Path 230777",
    d: "M2379.185,1991.94l9.655,2.127-5.174,6.36Z",
    transform: "translate(-2342.084 -1962.844)",
    fill: "#97a6b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230778",
    "data-name": "Path 230778",
    d: "M2263.573,2230.59l8.656,2.987.659-7.417Z",
    transform: "translate(-2260.097 -2128.943)",
    fill: "#97a6b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230779",
    "data-name": "Path 230779",
    d: "M2294.9,2430.748l8.434,3.05,1.791-5.634Z",
    transform: "translate(-2282.313 -2272.197)",
    fill: "#97a6b7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_230780",
    "data-name": "Path 230780",
    d: "M2502.32,2017.1l-12.464-2.318a90.331,90.331,0,0,0-1.36-24.636l11.682-4.131a6.338,6.338,0,0,0,3.785-8.005l-2.933-8.791a6.18,6.18,0,0,0-7.826-4.01l-11.513,3.951a93.164,93.164,0,0,0-13.757-21.386l7.913-9.154a6.582,6.582,0,0,0-.651-9.106l-7.037-6.436a6.268,6.268,0,0,0-8.995.363l-7.907,9.047a94.849,94.849,0,0,0-23.4-12.226l2.265-12.063a6.985,6.985,0,0,0-5.285-7.972l-9.614-2.263a6.348,6.348,0,0,0-7.82,4.962l-2.29,12.2a95.977,95.977,0,0,0-27.1,1.06l-4.4-12.241a7.381,7.381,0,0,0-8.917-4.569l-9.721,2.883a6.471,6.471,0,0,0-4.26,8.547l4.589,12.54a95.275,95.275,0,0,0-22.923,14.79l-10.843-9.14a7.508,7.508,0,0,0-10.277.414l-6.936,7.539a6.736,6.736,0,0,0,.91,9.828l11.249,9.3a91.174,91.174,0,0,0-11.658,24.3l-15.062-2.8a7.254,7.254,0,0,0-8.636,5.48l-1.888,10.056a7.132,7.132,0,0,0,6.08,8.135l15.493,2.709a90.3,90.3,0,0,0,2.875,26.294l-15.1,5.181a6.8,6.8,0,0,0-4.42,8.866l3.744,9.466a7.453,7.453,0,0,0,9.453,3.974l15.3-5.411a93.626,93.626,0,0,0,15.847,20.592l-10.489,12a6.414,6.414,0,0,0,.877,9.473l8.037,6.087a7.453,7.453,0,0,0,9.993-1.157l10.434-12.07a95.243,95.243,0,0,0,23.614,9.706l-2.836,15.107a6.243,6.243,0,0,0,5.505,7.366l9.806,1.241a7.108,7.108,0,0,0,7.834-5.606l2.805-14.943a95.9,95.9,0,0,0,24.858-2.853l5.009,13.687a6.223,6.223,0,0,0,8.274,3.478l8.913-3.558a6.638,6.638,0,0,0,3.916-8.282l-4.834-13.439a95.073,95.073,0,0,0,20.088-14.134l10.621,8.783a6.239,6.239,0,0,0,8.77-1.016l5.933-7.191a6.285,6.285,0,0,0-.629-8.8l-10.244-8.635a91.181,91.181,0,0,0,10.71-21.908l12.825,2.243a6.255,6.255,0,0,0,7.132-5.1l1.7-9.031A6.149,6.149,0,0,0,2502.32,2017.1ZM2387.489,2072.5c-37.126-5.553-62.608-39.956-55.718-76.661s43.19-59.917,79.891-52.1c35.454,7.553,58.075,41.439,51.6,75.916S2423.353,2077.868,2387.489,2072.5Z",
    transform: "translate(-2271.125 -1896.067)",
    fill: "#d8dee8"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2131",
    "data-name": "Group 2131",
    transform: "translate(494.49 508.158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2130",
    "data-name": "Group 2130",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2129",
    "data-name": "Group 2129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2123",
    "data-name": "Group 2123",
    transform: "translate(82.833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2122",
    "data-name": "Group 2122"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230781",
    "data-name": "Path 230781",
    d: "M965.759,1152.821c-6.694,11.1-18.358,26.161-30.986,43.632l210.766,30.517c-23.576-64.183-56.812-131.588-7.173-243.035,23.294-52.3,85.207-144.251,59.723-205.571-29.032-69.861-86.471-39.695-101.044-93.781C1074.267,600.045,1002.307,541.237,925,583.25c-76.3,41.465-73.736,192.968,26.8,358.707C1010.454,1069.029,1000.713,1094.881,965.759,1152.821Z",
    transform: "translate(-871.63 -569.346)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2121",
    "data-name": "Group 2121",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2120",
    "data-name": "Group 2120",
    transform: "translate(-10.758 -61.491)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2119",
    "data-name": "Group 2119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_230782",
    "data-name": "Path 230782",
    d: "M1108.554,1050.083c1.522-27.68,1.554-53.864,1.588-81.587l.013-9.243c-.806-13.35-1.239-26.535-1.657-39.286-.944-28.792-1.836-55.988-6.709-84.859-.094-1.687-.1-3.324-.112-5.059-.032-6.194-.066-12.6-3.661-18.724l-.083-.254c-14.485-152.7-60.713-304.972-137.4-452.581l1.1-.569c76.735,147.7,123,300.084,137.518,452.9,3.7,6.377,3.73,13.2,3.761,19.224.009,1.719.017,3.343.1,4.93,4.879,28.884,5.772,56.12,6.718,84.955.418,12.742.85,25.919,1.657,39.29l-.013,9.281c-.033,27.739-.066,53.94-1.59,81.653Z",
    transform: "translate(-923.921 -357.921)",
    fill: "#fcfdfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230783",
    "data-name": "Path 230783",
    d: "M1464.5,1468.54c-1.354-72.215,36.736-158,68.927-217.245a1025.37,1025.37,0,0,1,70.863-112.361l.989.741a1024.136,1024.136,0,0,0-70.774,112.225c-32.117,59.112-70.117,144.675-68.769,216.617Z",
    transform: "translate(-1281.29 -911.785)",
    fill: "#fcfdfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230784",
    "data-name": "Path 230784",
    d: "M1294.071,719.409c-5.707-76.551,6.032-158.212,9.89-185.046.737-5.133,1.225-8.524,1.2-9.182l1.235-.042c.025.737-.355,3.414-1.215,9.4-3.853,26.8-15.577,108.361-9.88,184.778Z",
    transform: "translate(-1159.361 -476.506)",
    fill: "#fcfdfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230785",
    "data-name": "Path 230785",
    d: "M996.886,1306.409C971.053,1240.458,836,1181.984,834.64,1181.4l.486-1.135c1.366.585,136.891,59.267,162.91,125.694Z",
    transform: "translate(-834.64 -941.096)",
    fill: "#fcfdfe"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2128",
    "data-name": "Group 2128",
    transform: "translate(0 180.386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2127",
    "data-name": "Group 2127"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230787",
    "data-name": "Path 230787",
    d: "M765.177,1359.7c1.147,97.841,48.338,65.6,91.853,75.258,50.221,72.663,54.953,140.08-20.031,198.3l-83.55-12.5c-31-1.439-67.377-10.914-65.324-52.193,2.321-46.686,13.362-76.338-39.334-99.266S573.46,1404.54,594.8,1356.953c22.456-50.077-30.216-117.578,8.278-151.13C670.149,1147.36,763.982,1257.823,765.177,1359.7Z",
    transform: "translate(-586.822 -1189.573)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2126",
    "data-name": "Group 2126",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2125",
    "data-name": "Group 2125",
    transform: "translate(-10.429 -10.769)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2124",
    "data-name": "Group 2124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_230788",
    "data-name": "Path 230788",
    d: "M877.795,1508.539A640.309,640.309,0,0,1,787.965,1382.5,620.349,620.349,0,0,1,731.473,1238.7a584.96,584.96,0,0,1-15.1-86.034l1.257-.123a583.81,583.81,0,0,0,15.066,85.847,619,619,0,0,0,56.377,143.5,639.042,639.042,0,0,0,89.651,125.8Z",
    transform: "translate(-668.268 -1152.545)",
    fill: "#fcfdfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230789",
    "data-name": "Path 230789",
    d: "M960.789,2504.225l-.574-1.127c15.518-7.9,33.822-14.069,54.406-18.322a211.475,211.475,0,0,1,28.96-3.975l.083,1.261a209.971,209.971,0,0,0-28.786,3.953C994.4,2490.244,976.206,2496.371,960.789,2504.225Z",
    transform: "translate(-841.189 -2094.493)",
    fill: "#fcfdfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230790",
    "data-name": "Path 230790",
    d: "M686.926,1943.49c-43.144-41.734-134.983-37.92-135.9-37.871l-.059-1.263c.931-.04,93.3-3.891,136.842,38.226Z",
    transform: "translate(-550.963 -1685.624)",
    fill: "#fcfdfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230791",
    "data-name": "Path 230791",
    d: "M830.327,1312.843c-12.914-66.581,36.986-143.521,37.492-144.29l1.056.694c-.5.766-50.121,77.285-37.306,143.356Z",
    transform: "translate(-747.564 -1163.897)",
    fill: "#fcfdfe"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2137",
    "data-name": "Group 2137",
    transform: "translate(553.652 631.422)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230793",
    "data-name": "Path 230793",
    d: "M1177.505,1578.056c0,6.112-4.642,11.308-10.381,11.606l-364.743,18.947a11.346,11.346,0,0,1-12.138-11.365V1056.1a11.226,11.226,0,0,1,12.138-11.255l4.886-.261,359.857,22.514c5.739.35,10.381,5.588,10.381,11.7Z",
    transform: "translate(-790.243 -1029.633)",
    fill: "url(#linear-gradient-5)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230794",
    "data-name": "Path 230794",
    d: "M1202.212,1577.773c0,6.112-4.642,11.308-10.381,11.606l-364.743,18.946a11.347,11.347,0,0,1-12.138-11.365V1055.82a11.226,11.226,0,0,1,12.138-11.255l364.743,22.253c5.739.35,10.381,5.588,10.381,11.7Z",
    transform: "translate(-807.764 -1029.602)",
    fill: "url(#linear-gradient-6)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230795",
    "data-name": "Path 230795",
    d: "M1165.714,1117.071c-9.066,11.656-10.361,33.673,5.18,42.739,33.673,20.722,77.707,14.246,110.085-7.771,23.83-16.681,13.682-47.607,6.862-72.62l-71.735-4.377C1209.934,1092.3,1177.083,1101.911,1165.714,1117.071Z",
    transform: "translate(-1051.764 -1051.231)",
    fill: "url(#linear-gradient-7)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230796",
    "data-name": "Path 230796",
    d: "M1233.824,1687.765c0,5.411-4.125,9.991-9.222,10.23l-330.259,15.457a10.01,10.01,0,0,1-10.625-10.041V1240.2a9.967,9.967,0,0,1,10.625-10l330.259,16.639c5.1.257,9.222,4.851,9.222,10.263Z",
    transform: "translate(-856.532 -1161.253)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230797",
    "data-name": "Path 230797",
    d: "M1374.07,1064.025a5.871,5.871,0,0,0-5.519-5l-17.38-.934c-7.855-.422-13.535-6.971-13.163-15.2l.862-19.069a6.071,6.071,0,0,0-5.657-6.562l-5.611-.349c-4.268-.265-7.189-4.087-6.516-8.537,1.191-7.872-3.984-14.664-11.58-15.172-7.621-.51-14.788,5.494-15.987,13.411a9.14,9.14,0,0,1-3.163,5.587,8.452,8.452,0,0,1-5.913,2.028l-5.728-.356a7.72,7.72,0,0,0-7.7,5.821l-4.975,19.11c-2.151,8.26-9.948,14.183-18.123,13.744l-18.286-.982a7.927,7.927,0,0,0-7.345,4.459l-13.124,26.335,1.128,1.441,168.344,6.549Zm-67.045-54.424a3.737,3.737,0,0,1-3.409-4.45,4.6,4.6,0,0,1,4.678-3.93,3.738,3.738,0,0,1,3.4,4.45A4.6,4.6,0,0,1,1307.024,1009.6Z",
    transform: "translate(-1087.321 -993.171)",
    fill: "#6165d7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230798",
    "data-name": "Path 230798",
    d: "M1377.948,1068.981a5.871,5.871,0,0,0-5.519-5l-17.38-.934c-7.855-.422-13.535-6.971-13.163-15.2l.863-19.069a6.071,6.071,0,0,0-5.657-6.562l-5.611-.349c-4.269-.265-7.19-4.087-6.516-8.536,1.191-7.872-3.984-14.664-11.58-15.172-7.621-.51-14.788,5.494-15.986,13.411a9.14,9.14,0,0,1-3.164,5.587,8.451,8.451,0,0,1-5.913,2.028l-5.727-.356a7.719,7.719,0,0,0-7.7,5.821l-4.975,19.11c-2.151,8.26-9.948,14.183-18.123,13.744l-18.287-.982a7.928,7.928,0,0,0-7.344,4.459l-13.124,26.335,169.472,7.99Zm-67.045-54.424a3.738,3.738,0,0,1-3.41-4.45,4.6,4.6,0,0,1,4.678-3.93,3.738,3.738,0,0,1,3.4,4.45A4.6,4.6,0,0,1,1310.9,1014.557Z",
    transform: "translate(-1090.072 -996.686)",
    fill: "url(#linear-gradient-8)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2136",
    "data-name": "Group 2136",
    transform: "translate(60.747 119.576)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_230799",
    "data-name": "Path 230799",
    d: "M1386.794,1441.833l-156.372-6.315v-31.205l156.372,7.67Z",
    transform: "translate(-1163.147 -1404.313)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2132",
    "data-name": "Group 2132",
    transform: "translate(160.12 80.403)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_230800",
    "data-name": "Path 230800",
    d: "M1682.368,1711.99a1.882,1.882,0,0,1-1.724,2.051l-129.127-2.89a2.09,2.09,0,0,1-1.861-2.213v-26.058a1.96,1.96,0,0,1,1.861-2.114l129.127,4.008a2.007,2.007,0,0,1,1.724,2.143Z",
    transform: "translate(-1549.655 -1680.766)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230801",
    "data-name": "Path 230801",
    d: "M1682.368,1859.964a1.9,1.9,0,0,1-1.724,2.066l-129.127-1.784a2.068,2.068,0,0,1-1.861-2.2v-7.239a1.993,1.993,0,0,1,1.861-2.139l129.127,2.21a1.973,1.973,0,0,1,1.724,2.119Z",
    transform: "translate(-1549.655 -1799.837)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230802",
    "data-name": "Path 230802",
    d: "M1682.368,1953.461a1.919,1.919,0,0,1-1.724,2.079l-129.127-.772a2.049,2.049,0,0,1-1.861-2.182v-7.238a2.012,2.012,0,0,1,1.861-2.154l129.127,1.2a1.955,1.955,0,0,1,1.724,2.105Z",
    transform: "translate(-1549.655 -1866.869)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230803",
    "data-name": "Path 230803",
    d: "M1682.368,2046.958a1.938,1.938,0,0,1-1.724,2.093l-129.127.24a2.03,2.03,0,0,1-1.861-2.168v-7.238a2.031,2.031,0,0,1,1.861-2.169l129.127.186a1.936,1.936,0,0,1,1.724,2.092Z",
    transform: "translate(-1549.655 -1933.901)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230804",
    "data-name": "Path 230804",
    d: "M1682.368,2138.442a1.956,1.956,0,0,1-1.724,2.106l-129.127,1.252a2.011,2.011,0,0,1-1.861-2.154v-7.238a2.05,2.05,0,0,1,1.861-2.183l129.127-.826a1.919,1.919,0,0,1,1.724,2.078Z",
    transform: "translate(-1549.655 -1998.919)",
    fill: "#d8dee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2133",
    "data-name": "Group 2133",
    transform: "translate(0 74.657)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_230805",
    "data-name": "Path 230805",
    d: "M1114.687,1811.186l-108.213,1.082c-4.063.041-7.364-3.611-7.364-8.157v-135.1c0-4.546,3.3-8.128,7.364-8l108.213,3.387c3.818.12,6.908,3.778,6.908,8.172v130.589C1121.595,1807.554,1118.505,1811.147,1114.687,1811.186Z",
    transform: "translate(-999.11 -1661.01)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230806",
    "data-name": "Path 230806",
    d: "M1006.227,1664.654l.14,0,108.214,3.357c2.1.065,3.815,2.12,3.815,4.58v130.62c0,2.369-1.645,4.324-3.69,4.358l-108.212,1.053a4.34,4.34,0,0,1-4.128-4.566V1668.993A4.093,4.093,0,0,1,1006.227,1664.654Zm0-3.644c-3.949.022-7.117,3.551-7.117,8v135.1c0,4.546,3.3,8.2,7.364,8.157l108.213-1.083h.043c3.8-.065,6.865-3.647,6.865-8.025V1672.572c0-4.394-3.09-8.053-6.908-8.172l-108.213-3.387Q1006.35,1661.009,1006.227,1661.01Z",
    transform: "translate(-999.11 -1661.01)",
    fill: "#d8dee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2134",
    "data-name": "Group 2134",
    transform: "translate(1.743 280.109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_230807",
    "data-name": "Path 230807",
    d: "M1075.159,2379.346l-69.218,1.465a.869.869,0,0,1-.839-.919v-10.286a.911.911,0,0,1,.839-.951l69.218-1.236a.85.85,0,0,1,.807.9v10.087A.891.891,0,0,1,1075.159,2379.346Z",
    transform: "translate(-1005.102 -2367.42)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230808",
    "data-name": "Path 230808",
    d: "M1123.631,2459.113l-117.69,3.291a.862.862,0,0,1-.839-.913v-10.286a.918.918,0,0,1,.839-.957l117.69-2.9a.828.828,0,0,1,.786.887v9.951A.882.882,0,0,1,1123.631,2459.113Z",
    transform: "translate(-1005.102 -2424.101)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230809",
    "data-name": "Path 230809",
    d: "M1123.631,2542.017l-117.69,4.09a.855.855,0,0,1-.839-.908v-10.285a.926.926,0,0,1,.839-.963l117.69-3.7a.821.821,0,0,1,.786.882v9.95A.889.889,0,0,1,1123.631,2542.017Z",
    transform: "translate(-1005.102 -2482.893)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230810",
    "data-name": "Path 230810",
    d: "M1123.631,2624.919l-117.69,4.89a.849.849,0,0,1-.839-.9v-10.285a.933.933,0,0,1,.839-.968l117.69-4.5a.814.814,0,0,1,.786.876v9.951A.9.9,0,0,1,1123.631,2624.919Z",
    transform: "translate(-1005.102 -2541.684)",
    fill: "#d8dee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2135",
    "data-name": "Group 2135",
    transform: "translate(160.12 276.735)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_230811",
    "data-name": "Path 230811",
    d: "M1650.329,2367.119l-99.906,2.115a.818.818,0,0,1-.768-.88v-9.841a.858.858,0,0,1,.768-.91l99.906-1.784a.791.791,0,0,1,.725.857v9.557A.829.829,0,0,1,1650.329,2367.119Z",
    transform: "translate(-1549.655 -2355.819)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230812",
    "data-name": "Path 230812",
    d: "M1679.931,2444.132l-129.508,3.621a.812.812,0,0,1-.768-.875v-9.841a.865.865,0,0,1,.768-.915l129.508-3.192a.776.776,0,0,1,.712.845v9.474A.826.826,0,0,1,1679.931,2444.132Z",
    transform: "translate(-1549.655 -2410.503)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230813",
    "data-name": "Path 230813",
    d: "M1679.931,2523.062l-129.508,4.5a.805.805,0,0,1-.768-.869v-9.842a.872.872,0,0,1,.768-.92l129.508-4.072a.769.769,0,0,1,.712.841v9.474A.832.832,0,0,1,1679.931,2523.062Z",
    transform: "translate(-1549.655 -2466.477)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230814",
    "data-name": "Path 230814",
    d: "M1679.931,2601.991l-129.508,5.381a.8.8,0,0,1-.768-.864v-9.841a.879.879,0,0,1,.768-.926l129.508-4.951a.763.763,0,0,1,.712.835v9.474A.839.839,0,0,1,1679.931,2601.991Z",
    transform: "translate(-1549.655 -2522.451)",
    fill: "#d8dee8"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_230815",
    "data-name": "Path 230815",
    d: "M1372.43,1203.626l-17.38-.934a13.6,13.6,0,0,1-11.622-7.652c-16.105,3.37-33.074-.151-50.043,3.243-11.656,2.59-10.361,20.722-23.312,22.017-18.577,2.51-36.958,2.685-55.145,2.863l-1.891,3.795,169.472,7.99-4.56-26.324A5.871,5.871,0,0,0,1372.43,1203.626Z",
    transform: "translate(-1090.072 -1136.329)",
    opacity: 0.3,
    fill: "url(#linear-gradient-9)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2139",
    "data-name": "Group 2139",
    transform: "translate(528.197 915.08)"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230816",
    "data-name": "Path 230816",
    d: "M1304.614,3156.605s17.032,8.655,17.31,10.036-10.953-.463-15.538-.264-8.357-1.316-7.942-3.487,2.02-7.633,2.02-7.633Z",
    transform: "translate(-1125.162 -2810.097)",
    fill: "url(#linear-gradient-10)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230817",
    "data-name": "Path 230817",
    d: "M1306.475,3133.24l-1.036,8.574s-2.7,1.073-4.508-.2l-.773-9.4Z",
    transform: "translate(-1126.401 -2793.756)",
    fill: "url(#linear-gradient-11)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230818",
    "data-name": "Path 230818",
    d: "M1039.852,3136.448l-1.981,3.556a4.673,4.673,0,0,0-.453,3.325c.693,2.957,2.076,8.719,2.68,10.222.822,2.047,11.843,3.263,11.843,3.263s.983-1.546-1.306-3.414-3.759-2.162-4.567-4.918-1.346-10.553-1.346-10.553Z",
    transform: "translate(-939.986 -2796.758)",
    fill: "url(#linear-gradient-12)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230819",
    "data-name": "Path 230819",
    d: "M1052.751,3102.888c-.724.645-4.264,12.658-4.264,12.658s-1.146,1.638-3.323-.78-.985-1.085-.985-1.085l.408-11.815Z",
    transform: "translate(-944.639 -2772.234)",
    fill: "url(#linear-gradient-13)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230820",
    "data-name": "Path 230820",
    d: "M1255.121,2514.425c.9,25.575.935,53.362-.381,83.047-1.482,33.427-4.46,64.322-8.213,92.328-1.4.05-2.861.058-4.392.01-1.034-.032-2.036-.089-3-.163a231.322,231.322,0,0,1-6.311-22.566,240.229,240.229,0,0,1-4.406-26.423c-3.28-28.968.564-31.495-2.1-52.963-2.357-19.013-5.71-19.755-9.645-46.75-4.27-29.29-1.092-33.684.454-35.271C1223.7,2498.917,1239.162,2503.518,1255.121,2514.425Z",
    transform: "translate(-1065.675 -2347.194)",
    fill: "url(#linear-gradient-14)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_230821",
    "data-name": "Path 230821",
    d: "M1217.124,2505.684c6.277-6.446,20.63-2.544,35.791,7.294-17.441,21.068-19.342,34.735-17.251,43.6,2.363,10.023,9.547,12.909,9.52,23.868-.034,13.468-10.9,17.035-10.674,31.287.153,9.424,4.93,9.326,6.058,20.965,1.335,13.772-4.906,18.517-2.885,28.706.87,4.384,3.352,10.112,10.421,16.012-.51,4.184-1.032,8.326-1.577,12.39-1.395.049-2.861.058-4.392.009-1.034-.032-2.036-.088-3-.163a231.354,231.354,0,0,1-6.311-22.566,240.255,240.255,0,0,1-4.406-26.423c-3.28-28.968.564-31.495-2.1-52.963-2.357-19.013-5.71-19.756-9.645-46.75C1212.4,2511.665,1215.578,2507.271,1217.124,2505.684Z",
    transform: "translate(-1065.675 -2347.204)",
    opacity: 0.3,
    fill: "url(#linear-gradient-15)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230822",
    "data-name": "Path 230822",
    d: "M1114.536,2507.4a597.112,597.112,0,0,0-45.7,91.74,620.383,620.383,0,0,0-24.715,76.767,8.339,8.339,0,0,1-5.027.871,9.2,9.2,0,0,1-5.694-3.44,184.73,184.73,0,0,1-1.306-40.781,155.577,155.577,0,0,1,5.13-30.652c4.146-14.952,7-15.792,12.4-31.61,5.614-16.418,4.254-20.515,9.63-41.062a292.214,292.214,0,0,1,12.006-36.026Z",
    transform: "translate(-935.893 -2340.593)",
    fill: "url(#linear-gradient-16)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230823",
    "data-name": "Path 230823",
    d: "M885.359,2033.709c16.582-10.83,23.687-9.581,28.494-19.308,4.755-9.621,4.744-24.885-3.124-32.972-.578-.594-6.571-6.562-14.681-5.539-12.267,1.547-13.17,17.043-26.929,24.143-11.659,6.016-24.373,1.785-32.977-1.079-20.719-6.9-23.8-19.939-34.539-17.86-13.461,2.6-14.652,24.249-28.062,25.583-8.963.891-11.1-8.512-22.882-11.1-13.846-3.043-29.04,5.953-37.561,16.894-15.574,20-11.472,49.843-1.727,68.062,8.006,14.967,25.219,32.184,39.719,28.48,11.456-2.926,15.185-17.366,25.04-15.929,7.007,1.022,7.26,8.634,15.542,12.551,13.6,6.433,30.39-5.827,34.97-9.172,13.054-9.533,10.975-15.629,27.807-34.741C861.1,2054.171,870.675,2043.3,885.359,2033.709Z",
    transform: "translate(-702.72 -1973.652)",
    fill: "url(#linear-gradient-17)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230824",
    "data-name": "Path 230824",
    d: "M1739.036,1986.414s2.8-3.921,4.58-6.834,10.078-11.1,10.078-11.1.632,1.3-1.154,3.377-5.547,5.641-4.682,7.148,3.3,2.835,1.542,5.681-4.811.9-6.372,3.185-3.161,4.772-3.161,4.772Z",
    transform: "translate(-1437.635 -1968.48)",
    fill: "url(#linear-gradient-18)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230825",
    "data-name": "Path 230825",
    d: "M1501.548,2021.346l5.67,9.591a102.956,102.956,0,0,1-11.3,24.766,95.2,95.2,0,0,1-24.506,26.135c-18.729,13.338-52.851,25.781-62.839,11.588-8.913-12.665,5.473-40.737,8.122-45.776a66.065,66.065,0,0,0,25.5,7.421,59.741,59.741,0,0,0,24.256-2.791C1486.592,2045.361,1497.774,2027.9,1501.548,2021.346Z",
    transform: "translate(-1201.241 -2005.97)",
    fill: "url(#linear-gradient-19)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230826",
    "data-name": "Path 230826",
    d: "M1086.991,2115.479c-.942,4.736-15.673,2.2-18.713,10.793-1.631,4.613,1.832,7.543,1.977,15.378.163,8.771-4.018,13.751-7.225,20.651-4.7,10.106-4.714,20.012-4.749,39.823-.05,28.2,6.186,33.872.864,42.961-6.928,11.831-23.566,12.586-28.062,12.791-15.379.7-17.2-7.471-33.891-8.447-19.058-1.114-21.772,9.245-35.4,4.827-12.451-4.036-16.641-14.772-26.336-12.549-6.059,1.388-7.666,6.327-13.383,5.792-5.745-.538-11.684-6.231-12.088-12.069-.5-7.256,7.429-16.4,19.86-16.411,4.94,1.939,13.128,4.186,22.234,1.69,14.921-4.09,22.681-18.275,31.3-34.031,5.963-10.9,16.923-30.932,17.053-57.2.054-10.833-1.777-14,.863-19.792,8.574-18.8,41.84-16,44.657-15.724C1068.616,2096.147,1088.129,2109.76,1086.991,2115.479Z",
    transform: "translate(-849.686 -2057.253)",
    fill: "url(#linear-gradient-20)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2138",
    "data-name": "Group 2138",
    transform: "translate(182.2 79.883)"
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230827",
    "data-name": "Path 230827",
    d: "M1391.72,2250.037l-41.783,1.823a1.147,1.147,0,0,0-1.016.832l-19.683,61.052c-.282.876.6,3.066,1.431,2.967l41.31-6.283a1.156,1.156,0,0,0,.931-.8l20.479-56.985C1393.679,2251.8,1392.53,2250,1391.72,2250.037Z",
    transform: "translate(-1329.184 -2248.031)",
    fill: "url(#linear-gradient-21)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230828",
    "data-name": "Path 230828",
    d: "M1393.915,2255.174,1352.132,2257a1.147,1.147,0,0,0-1.017.832l-19.683,61.052a1.231,1.231,0,0,0,1.181,1.68l41.56-5a1.154,1.154,0,0,0,.931-.8l19.906-57.878A1.243,1.243,0,0,0,1393.915,2255.174Z",
    transform: "translate(-1330.73 -2251.674)",
    fill: "url(#linear-gradient-22)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230829",
    "data-name": "Path 230829",
    d: "M1467.417,2248.917l1.61-4.867a.667.667,0,0,0-.564-.906h-15.209a.613.613,0,0,0-.573.469l-1.529,5.384a.661.661,0,0,0,.592.876l15.128-.516A.611.611,0,0,0,1467.417,2248.917Z",
    transform: "translate(-1415.658 -2243.143)",
    fill: "url(#linear-gradient-23)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_230830",
    "data-name": "Path 230830",
    d: "M1399.562,2305.782c2.714-9.84-1.753-16.247,2.806-23.894,6.448-10.815,20.3-6.238,24.608-14.965,1.162-2.353,1.717-5.86.15-11.332l9.581-.417a1.243,1.243,0,0,1,1.1,1.711l-19.906,57.878a1.154,1.154,0,0,1-.931.8l-25.258,3.038A28.185,28.185,0,0,0,1399.562,2305.782Z",
    transform: "translate(-1373.523 -2251.675)",
    opacity: 0.3,
    fill: "url(#linear-gradient-24)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230831",
    "data-name": "Path 230831",
    d: "M1313.8,2385.9s6.314-1.4,8.749-3.118,5.018-4.468,8.608-4.318,7.2,2.192,5.545,2.66-4.757,4.146-7.124,5.594-7.775,1.579-8.782,1.5-4.983,2.594-4.983,2.594Z",
    transform: "translate(-1136.076 -2259.22)",
    fill: "url(#linear-gradient-25)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_230832",
    "data-name": "Path 230832",
    d: "M929.841,2251.766c4.94,1.938,13.128,4.186,22.234,1.69,14.921-4.09,22.681-18.275,31.3-34.031,5.963-10.9,16.923-30.932,17.053-57.2.054-10.833-1.777-14,.863-19.792a20.157,20.157,0,0,1,1.447-2.6c6.514,4.923,9.039,9.853,9.777,14.181,1.8,10.536-6.675,19.151-2.266,28.238,4.222,8.7,14.661,6.3,16.838,13.757,2.348,8.049-9.2,12.9-9.714,25.342-.611,14.927,15.442,22.237,12.628,32.221-2.438,8.653-15.872,8.03-15.866,12.671.008,5.518-.415-5.876,15.866-12.671,4.934-2.059,28.157,15.081,30.979,12.073.608,4.863.5,8.2-1.837,12.183-6.928,11.831-23.566,12.586-28.062,12.791-15.379.7-17.2-7.471-33.891-8.447-19.058-1.114-21.772,9.245-35.4,4.827-12.451-4.036-16.641-14.773-26.336-12.55-6.059,1.389-7.666,6.327-13.383,5.792-5.745-.538-11.684-6.231-12.088-12.069C909.479,2260.921,917.411,2251.78,929.841,2251.766Z",
    transform: "translate(-849.686 -2089.999)",
    opacity: 0.4,
    fill: "url(#linear-gradient-26)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230833",
    "data-name": "Path 230833",
    d: "M1144.734,2182.766l5.828,11.585c-2.995,1.64-35.018,18.581-58.229,1.81a39.75,39.75,0,0,1-14.608-18.376c-4.531-11.894-1.989-22.953-.341-30.136,4.082-17.781,15.625-36.432,32-43.926,6.256-2.863,13.683-4.311,20.669-5.673,5.924-1.155,15.236-2.571,15.434-1.568.1.49-2.067,1.114-3.569,2.065-9.228,5.836,2.488,29.94-8.357,41.5-10.39,11.073-23.874,9.245-26.047,19.28-1.01,4.665,1.081,8.863,2.013,10.732C1114.727,2180.49,1128.72,2185.16,1144.734,2182.766Z",
    transform: "translate(-966.846 -2059.012)",
    fill: "url(#linear-gradient-27)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230834",
    "data-name": "Path 230834",
    d: "M1336.7,2035.093s-3.761,12.224-8.444,14.128-12.088,4.087-13.018,4.934,24.884,10.217,39.358,5.9h0c-4.124-2.018-5.227-2.662-5.227-2.662a24.72,24.72,0,0,1-5.083-3.754,21.575,21.575,0,0,1-4.911-7.731l1.353-6.94Z",
    transform: "translate(-1137.076 -2015.719)",
    fill: "url(#linear-gradient-28)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230835",
    "data-name": "Path 230835",
    d: "M1377.506,2023.87s2.18,5.417,7.349,4.586c4.629-.745,4.393-13.762,1.249-15.979a5.577,5.577,0,0,0-4.756-.374,7.828,7.828,0,0,0-3.68,7.916c-1.02-.607-2.036-.512-2.388.034-.448.691.277,1.946.442,2.23A3.8,3.8,0,0,0,1377.506,2023.87Z",
    transform: "translate(-1179.571 -1999.16)",
    fill: "url(#linear-gradient-29)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2140",
    "data-name": "Group 2140",
    transform: "translate(750.876 1014.456)"
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230836",
    "data-name": "Path 230836",
    d: "M1497.938,3012.1H1487.49s-12.474,38.105-18.087,43.719,7.613,22.454,138.529,21.051c89.283-1.871,114.075-10.759,115.947-20.115s-10.045-20.115-9.935-25.729-15.551-18.926-15.551-18.926Z",
    transform: "translate(-1468.364 -2807.95)",
    fill: "url(#linear-gradient-30)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_230837",
    "data-name": "Path 230837",
    d: "M1749.314,3031.026c.111-5.613-15.551-18.926-15.551-18.926h-210.9s-1.933,5.906-4.62,13.409c7.688,5.961,17.659,7.371,27.162,7.371,14.66.666,28.653-6,41.98-1.333,23.989,8,47.312,19.991,73.3,13.327,15.993-4,31.319-10.662,47.978-10,10,0,20.657,10.662,13.327,19.324-20.657,21.99-53.309,8.663-81.3,13.993-16.659,3.332-31.985,2-47.978,2-2,0-4.665,2-6.664,2a203.6,203.6,0,0,1-29.758,1.972c20.617,1.966,48.8,3.111,87.01,2.7,89.283-1.871,114.075-10.759,115.947-20.115S1749.2,3036.64,1749.314,3031.026Z",
    transform: "translate(-1503.734 -2807.951)",
    opacity: 0.3,
    fill: "url(#linear-gradient-31)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 105.452,
    cy: 10.038,
    rx: 105.452,
    ry: 10.038,
    transform: "translate(19.126 194.11)",
    fill: "url(#linear-gradient-32)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 70.095,
    cy: 6.532,
    rx: 70.095,
    ry: 6.532,
    transform: "translate(54.482 194.11)",
    opacity: 0.3,
    fill: "url(#linear-gradient-33)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230838",
    "data-name": "Path 230838",
    d: "M2058.937,2644.711s195.2,24.131,236.582,22.885,32.388,41.389,6.122,41.322-240.593-40.409-240.593-40.409Z",
    transform: "translate(-1887.176 -2547.413)",
    fill: "url(#linear-gradient-34)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230839",
    "data-name": "Path 230839",
    d: "M1764.621,2310.343a36.114,36.114,0,0,0-13.683,13.683c-6.772,12.54.038,20.594-5.613,35.785-5.005,13.454-11.767,10.956-15.6,23.914-4.19,14.168,3.33,19.061-2.313,31.213-4.245,9.143-10.135,9.891-11.349,18.83-.189,1.393-.043,1.348,1.546,16.21,1.278,11.966,1.374,13.776,0,16.033-2.235,3.678-5.573,3.951-8.255,9.286a17.047,17.047,0,0,0-1.805,5.675c-.477,8.921,24.706,19.3,48.3,24.438,10.287,2.238,41.852,9.039,47.776-1.54,1.1-1.958.714-4.826.289-10.038-.671-8.227-2.723-9.594-2.4-13.688.575-7.319,7.542-8.221,12.311-16.455,4.968-8.576.143-12.319,2.837-25.794,3.165-15.828,10.666-14.9,13.929-30.437,2.907-13.844-2.61-16.661,1.847-27.717,3.861-9.579,9.239-10.533,12.515-19.521,3.331-9.142,1.455-18.271-.69-24.615a117.943,117.943,0,0,0-79.641-25.26Z",
    transform: "translate(-1637.981 -2310.168)",
    fill: "url(#linear-gradient-35)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_230840",
    "data-name": "Path 230840",
    d: "M1844.261,2335.6a117.943,117.943,0,0,0-79.641-25.26,37.5,37.5,0,0,0-11.778,10.613c8.708-2.062,28.88-5.431,48.342,4.991,2.672,1.431,23.907,12.8,22.822,26.127-.7,8.579-9.875,8.447-15.084,20.3-6.162,14.028,3.809,20.754-1.547,37.144-4.112,12.579-10.933,11.516-13.929,24.247-2.936,12.479,3.151,15.493-.516,26.311-4.728,13.95-18.7,20.306-20.636,21.151-1.417.62-7.471,3.165-17.347,3.225-18.951.114-33.8-9.033-41.209-14.493a15.233,15.233,0,0,0-4.383,5.336,17.047,17.047,0,0,0-1.805,5.675c-.477,8.921,24.706,19.3,48.3,24.438,10.287,2.238,41.852,9.039,47.776-1.54,1.1-1.958.714-4.826.289-10.038-.671-8.227-2.723-9.594-2.4-13.688.575-7.319,7.542-8.221,12.311-16.455,4.968-8.576.143-12.319,2.837-25.794,3.165-15.828,10.666-14.9,13.929-30.437,2.907-13.844-2.61-16.661,1.847-27.717,3.861-9.579,9.239-10.533,12.515-19.521C1848.283,2351.077,1846.407,2341.948,1844.261,2335.6Z",
    transform: "translate(-1637.981 -2310.168)",
    opacity: 0.3,
    fill: "url(#linear-gradient-35)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230841",
    "data-name": "Path 230841",
    d: "M2373.2,2711.438a27.357,27.357,0,0,1-1.409,2.456c-13.63,22.19-41.673,19.632-64.661,19.011-30.769-.138-58.811-12.781-88.315-22.517-20.281-7.212-42.394-5.536-60.972,6.621,58.266,10.785,193.43,35.391,213.94,35.443C2396.311,2752.515,2405.767,2715.332,2373.2,2711.438Z",
    transform: "translate(-1957.313 -2590.948)",
    opacity: 0.3,
    fill: "url(#linear-gradient-37)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2142",
    "data-name": "Group 2142",
    transform: "translate(895.84 654.439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2141",
    "data-name": "Group 2141",
    transform: "translate(81.402 256.021)"
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230842",
    "data-name": "Path 230842",
    d: "M2414.924,2079.39c-27.264,53.81-64.339,59.525-75.271,60.069v.044s.319.026-.5.009c-.815.018-.5-.009-.5-.009v-.044c-9.938-.447-35.742-4.427-60.21-36.092a149.539,149.539,0,0,1-15.035-23.977c-31.674-62.506-8.643-94.7-8.643-94.7l83.888-.2v-.009l.5.009.5-.009v.009l35.743.088,48.287.114S2446.6,2016.884,2414.924,2079.39Z",
    transform: "translate(-2246.684 -1975.209)",
    fill: "url(#linear-gradient-38)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 85.175,
    cy: 10.788,
    rx: 85.175,
    ry: 10.788,
    transform: "translate(7.427)",
    fill: "url(#linear-gradient-39)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_230843",
    "data-name": "Path 230843",
    d: "M2492.376,2079.626c-27.264,53.81-64.339,59.525-75.271,60.069v.044s.319.026-.5.009c-.815.018-.5-.009-.5-.009v-.044c-9.938-.447-35.742-4.427-60.21-36.092.14-29.158,67.792-48.971,88.928-62.489,26.738-17.095,5.225-54.879,5.225-54.879,1.034-.491,2.042-.964,3.051-1.42l48.158.114S2524.05,2017.12,2492.376,2079.626Z",
    transform: "translate(-2324.136 -1975.445)",
    opacity: 0.3,
    fill: "url(#linear-gradient-40)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 44.415,
    cy: 56.832,
    rx: 44.415,
    ry: 56.832,
    transform: "translate(0 58.375)",
    fill: "url(#linear-gradient-41)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230844",
    "data-name": "Path 230844",
    d: "M2322.078,1200.32c0,70.7-69.949,128.01-156.23,128.01a188.95,188.95,0,0,1-38.406-3.9c-67.714-14.018-117.824-64.268-117.824-124.109,0-70.694,69.949-128.01,156.23-128.01a184.6,184.6,0,0,1,67.67,12.6C2285.916,1105.571,2322.078,1149.491,2322.078,1200.32Z",
    transform: "translate(-1997.164 -1072.31)",
    fill: "url(#linear-gradient-42)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230845",
    "data-name": "Path 230845",
    d: "M2091.14,1481.446l120.458,10.513c26.629,2.324,49.6-18.507,50.532-46.821l.994-30.212c.428-13-9.523-23.836-22.057-24.159l-171.72-4.429c-9.973-.257-17.961,8.807-17.961,20.205v26.52C2051.386,1457.947,2068.927,1479.508,2091.14,1481.446Z",
    transform: "translate(-2026.784 -1295.003)",
    fill: "#f4f7fa"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230846",
    "data-name": "Path 230846",
    d: "M2108.832,1492.1l128.893,9.488c19.036,1.4,35.3-13.645,35.931-33.75l.419-13.344c.405-12.893-9.437-23.694-21.817-24.073l-153.658-4.7c-10.075-.308-18.158,8.747-18.173,20.184l-.015,11.842C2080.387,1475.6,2092.98,1490.931,2108.832,1492.1Z",
    transform: "translate(-2047.367 -1322.931)",
    fill: "url(#linear-gradient-43)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230847",
    "data-name": "Path 230847",
    d: "M2433.3,1567.006a12.122,12.122,0,0,1-1.907-6.524c.13-7.546,7.692-13.3,16.985-12.83,9.4.475,16.961,7.121,16.787,14.823a11.361,11.361,0,0,1-2.244,6.4Z",
    transform: "translate(-2296.269 -1409.386)",
    fill: "#d8dee8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230848",
    "data-name": "Path 230848",
    d: "M2160.871,1552.047a12.062,12.062,0,0,1-1.8-6.2c.035-7.179,6.8-12.67,15.195-12.246,8.485.428,15.375,6.726,15.3,14.046a11.1,11.1,0,0,1-1.952,6.086Z",
    transform: "translate(-2103.153 -1399.422)",
    fill: "#d8dee8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_230849",
    "data-name": "Path 230849",
    d: "M2605.907,1231.038c0,70.7-69.949,128.01-156.23,128.01a188.95,188.95,0,0,1-38.406-3.9c-12.151-38.354,56.518-80.416,96.012-107.216,48.383-32.831,10.064-132.306,10.064-132.306C2569.744,1136.288,2605.907,1180.209,2605.907,1231.038Z",
    transform: "translate(-2280.993 -1103.027)",
    opacity: 0.3,
    fill: "url(#linear-gradient-44)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 44.415,
    cy: 56.832,
    rx: 44.415,
    ry: 56.832,
    transform: "translate(259.179 80.663)",
    fill: "url(#linear-gradient-41)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanPortfolio2);
export default __webpack_public_path__ + "static/media/woman_portfolio2.99f795f37540341f5e659226d9676382.svg";
export { ForwardRef as ReactComponent };